'use client';

import { useChatRuntimeContext } from "../internals/useChatRuntimeContext/index.js";
export function useChatPartRenderer(partType) {
  const {
    partRenderers
  } = useChatRuntimeContext();
  return partRenderers[partType] ?? null;
}